module.exports = __webpack_public_path__ + "img/Mode_Selector_Rest.ee310242.png";